import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IEditReportTaskDTO  } from "../../services/reporting-data-service/ReportScheduleModels";

export type UseReportTaskQueryParameters = {
    groupID: number;
    taskID: number;
    myReports: boolean;
} & BaseUseQueryParameters<IEditReportTaskDTO>;

export function useReportTask({
    groupID,
    taskID,
    myReports,
    enabled,
    onError,
    onSuccess,
    //refreshSeconds
}: UseReportTaskQueryParameters) {
    return useQuery<IEditReportTaskDTO, RestError>(
        keys.task(
            groupID,
            taskID,
            myReports
        ),
        ({ signal }) => {
            return ReportingDataService.getReportTask(
                groupID,
                taskID,
                myReports,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            //retry: false,
        }
    );
}
